<template>
    <svg class="cnm-icon" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 7.95703L10 0.957031L19 7.95703V18.957C19 19.4875 18.7893 19.9962 18.4142 20.3712C18.0391 20.7463 17.5304 20.957 17 20.957H3C2.46957 20.957 1.96086 20.7463 1.58579 20.3712C1.21071 19.9962 1 19.4875 1 18.957V7.95703Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
